/**
 * 附图上传服务接口。
 * 支持将 File[] 批量转为 base64 并添加到附图列表。
 */
export interface ClaimsImageUploadService {
    /**
     * 批量添加图片文件到附图列表。
     * @param files 文件数组
     */
    addFiles(files: File[]): Promise<void>;
}

export const ClaimsImageUploadService = Symbol.for('ClaimsImageUploadService');
